import { GrantsHistoryInterfaceV1 } from './GrantsHistoryInterfaceV1';
import { GrantsHistoryInterfaceType } from '@clientos/types';
import { internalLogger } from '../../../interface/v1/clientOsLogger';

let grantsHistoryInterfaceV1: GrantsHistoryInterfaceV1;

export function getGrantsHistoryInterfaceV1(): GrantsHistoryInterfaceType {
  return grantsHistoryInterfaceV1.getInterface();
}

export async function initializeGrantsHistoryInterfaceV1(): Promise<GrantsHistoryInterfaceType> {
  if (grantsHistoryInterfaceV1) return grantsHistoryInterfaceV1.getInterface();
  grantsHistoryInterfaceV1 = new GrantsHistoryInterfaceV1();

  return grantsHistoryInterfaceV1.getInterface();
}

// Keep backward compatibility
export default initializeGrantsHistoryInterfaceV1;

export function createNoopGrantsHistoryInterface(): GrantsHistoryInterfaceType {
  return {
    refresh: function (): Promise<void> {
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsHistoryInterface',
        methodName: 'refresh()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    checkGrantsHistory: function (): Promise<boolean> {
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsHistoryInterface',
        methodName: 'checkGrantsHistory()',
        message: 'Noop interface method called - returning false'
      });
      return Promise.resolve(false);
    },
    useReactCheckGrantsHistory() {
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsHistoryInterface',
        methodName: 'useReactCheckGrantsHistory()',
        message: 'Noop interface method called - returning false'
      });
      return {
        loading: false,
        reload: () => Promise.resolve(),
        data: false,
        error: undefined
      };
    }
  };
}
